import React, {useState, useEffect, useCallback, useRef} from 'react';
import {InputAdornment, TextField} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const InputText = ({
   value,
   onChangeFn = (value) => {},
   withDebounce = false,
   debounceDelay = 500,
   width = '200px',
   onDebounceStart = () => {},
   onDebounceEnd = () => {}
}) => {
  const [inputValue, setInputValue] = useState(value || '');
  const debounceTimeout = useRef(null);

  const debounce = (func, delay) => {
    return (...args) => {
      onDebounceStart();
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(async () => {
        await func(...args);
        onDebounceEnd();
      }, delay);
    };
  }

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const newValue = event.target.value;
    setInputValue(newValue);

    if (!withDebounce) {
      onChangeFn(newValue);
    } else {
      debouncedChange(newValue);
    }
  };

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChangeFn(newValue);
    }, debounceDelay),
    [onChangeFn, debounceDelay]
  );

  return (
    <TextField
      sx={{
        "& .MuiFilledInput-root": {
          borderBottom: "none",
          fontSize: "12px",
          backgroundColor: "#F9FBFF",
          borderRadius: '8px',
          width: `${width}`,
          "&:hover": {
            backgroundColor: "#e6e7ec",
            borderBottom: "none!important", // Removes hover border
            "&::before": { borderBottom: "none!important"}
            },
          "&:before": {
            borderBottom: "none" // Removes the initial underline
          },
          "&:after": {
            borderBottom: "none" // Removes the focused underline
          },
          "&:focus": {
            backgroundColor: "#e6e7ec",
            borderBottom: "none" // No border on focus
          },
          "&.Mui-focused": {
            backgroundColor: "#e6e7ec",
            borderBottom: "none" // Prevents border on focus state
          },
        },
        ".MuiInputBase-input": {
          paddingTop: "7px",
          paddingBottom: "7px",
          color: '#1B3665'
        },
      }}
      value={inputValue}
      onChange={handleChange}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation()
      }}
      variant="filled"
      placeholder="Search"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment sx={{ marginTop: "0!important" }} position="start">
              <SearchIcon sx={{ fontSize: '20px' }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
}

export default InputText;
